import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12ae9748")

_pushScopeId("data-v-12ae9748")
const _hoisted_1 = {
  key: 0,
  class: "single-employee"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Error = _resolveComponent("Error")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_multi_select_list = _resolveComponent("multi-select-list")!
  const _component_leave_list = _resolveComponent("leave-list")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.$route.params.uin)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.lookUpUserInfoData)
          ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
          : (_ctx.lookUpUserInfoData?.error)
            ? (_openBlock(), _createBlock(_component_Error, {
                key: 1,
                error: _ctx.lookUpUserInfoData.error
              }, null, 8, ["error"]))
            : (_ctx.lookUpUserInfoData)
              ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_UserInfo, {
                    userInfoData: _ctx.lookUpUserInfoData,
                    userCalendarsData: _ctx.userCalendarsData
                  }, null, 8, ["userInfoData", "userCalendarsData"]),
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true),
                  (_ctx.$route.name === 'Manage Single Employee'
        || _ctx.$route.name === 'View/Edit User')
                    ? (_openBlock(), _createBlock(_component_multi_select_list, {
                        title: 'Pending Requests',
                        userLeaveList: _ctx.employeePendingRequestsData,
                        formatDate: _ctx.formatDate,
                        approveRequest: _ctx.approveRequest,
                        declineRequest: _ctx.declineRequest,
                        hrViewLeave: _ctx.hrViewLeave,
                        key: _ctx.leavePendingKey,
                        userInfoData: _ctx.lookUpUserInfoData,
                        isHRAdminReadOnly: _ctx.isHRAdminReadOnly
                      }, null, 8, ["userLeaveList", "formatDate", "approveRequest", "declineRequest", "hrViewLeave", "userInfoData", "isHRAdminReadOnly"]))
                    : _createCommentVNode("", true),
                  (_ctx.$route.name === 'Manage Single Employee'
        || _ctx.$route.name === 'View/Edit User')
                    ? (_openBlock(), _createBlock(_component_leave_list, {
                        title: 'Processed Requests',
                        userLeaveList: _ctx.employeeProcessedRequestsData,
                        formatDate: _ctx.formatDate,
                        declineRequest: _ctx.declineRequest,
                        deleteDeclined: _ctx.deleteDeclined,
                        hrViewLeave: _ctx.hrViewLeave,
                        key: _ctx.leaveProcessedKey,
                        userInfoData: _ctx.lookUpUserInfoData,
                        isHRAdminReadOnly: _ctx.isHRAdminReadOnly
                      }, null, 8, ["userLeaveList", "formatDate", "declineRequest", "deleteDeclined", "hrViewLeave", "userInfoData", "isHRAdminReadOnly"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_view, { userInfoData: _ctx.lookUpUserInfoData }, null, 8, ["userInfoData"])
                ], 64))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})